// extracted by mini-css-extract-plugin
export default {"wrapper":"increment-note__wrapper___R3l6v","icon":"increment-note__icon___OU51q","orangeIcon":"increment-note__orangeIcon___tQOzB"};